var touch = Modernizr.touch;
var headerFixed = false;
var mobile = false;
var $window = $(window);
var $animation_elements = $('.animation-element');
var statusVid = false;
var swiperFeat = false;
var swiperRel = false;
var swiperColl = false;
var swiperLastSell = false;
var swiperTop, featProp, relProp, colProp, lastsellProp, swiperGal;

// window.Vlitejs.registerProvider('vimeo', window.VlitejsVimeo);
// window.Vlitejs.registerProvider('youtube', window.VlitejsYoutube);

$.fn.serializeObject = function () {
    var o = {};
    var a = this.serializeArray();
    $.each(a, function () {
        if (o[this.name] !== undefined) {
            if (!o[this.name].push) {
                o[this.name] = [o[this.name]];
            }
            o[this.name].push(this.value || '');
        } else {
            o[this.name] = this.value || '';
        }
    });
    return o;
};

// Used to compensante Chrome/Safari bug (they don't care about scroll bar for width)
function scrollCompensate() {
    var inner = document.createElement('p');
    inner.style.width = "100%";
    inner.style.height = "200px";

    var outer = document.createElement('div');
    outer.style.position = "absolute";
    outer.style.top = "0px";
    outer.style.left = "0px";
    outer.style.visibility = "hidden";
    outer.style.width = "200px";
    outer.style.height = "150px";
    outer.style.overflow = "hidden";
    outer.appendChild(inner);

    document.body.appendChild(outer);
    var w1 = inner.offsetWidth;
    outer.style.overflow = 'scroll';
    var w2 = inner.offsetWidth;
    if (w1 === w2) { w2 = outer.clientWidth; }

    document.body.removeChild(outer);

    return (w1 - w2);
}

function getParameterByName(name) {
    name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
    var regex = new RegExp("[\\?&]" + name + "=([^&#]*)"),
        results = regex.exec(location.search);
    return results === null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
}

// Resize calculs
function resize() {
    if (mobile == false) {
        if ($(window).width() + scrollCompensate() < 760) {
            if ($('#collCollections').length != 0) {
                $('#collCollections').css('left', '');
            }
            mobile = true;
        } else {
            if ($('#collCollections').length != 0) {
                var colLeft = $('#btn-collCollections').offset();
                offLeft = colLeft.left;
                if ($(window).width() + scrollCompensate() > 1500) {
                    offLeft = offLeft - (($(window).width() - 1500) / 2);
                }
                $('#collCollections').css('left', offLeft);
            }
        }

    } else {
        if ($(window).width() + scrollCompensate() >= 760) {
            $('html,body').removeClass('ohidden');
            if ($('#collCollections').length != 0) {
                var colLeft = $('#btn-collCollections').offset();
                offLeft = colLeft.left;
                if ($(window).width() + scrollCompensate() > 1500) {
                    offLeft = offLeft - (($(window).width() - 1500) / 2);
                }
                $('#collCollections').css('left', offLeft);
            }
            mobile = false;
        } else {
            if ($('#collCollections').length != 0) {
                $('#collCollections').css('left', '');
            }
        }
    }

    if ($(window).width() + scrollCompensate() < 980) {
        if ($('#featured-properties').length && swiperFeat == false) {
            featProp = new Swiper('#featured-properties', {
                autoHeight: false,
                setWrapperSize: false,
                slidesPerView: 'auto',
                spaceBetween: 20,
                centeredSlides: true,
                loop: false,
                simulateTouch: false,
                setWrapperSize: true,
                keyboard: {
                    enabled: true
                },
                preloadImages: false,
                lazy: {
                    loadPrevNext: true,
                    loadPrevNextAmount: 1,
                    elementClass: 'swiper-lazy'
                },
                a11y: {
                    enabled: true,
                    prevSlideMessage: 'Mostrar propiedad anterior',
                    nextSlideMessage: 'Mostrar propiedad siguiente',
                    firstSlideMessage: 'Es la primera propiedad',
                    lastSlideMessage: 'Es la última propiedad',
                    paginationBulletMessage: 'Mostrar propiedad {{index}}',
                },
                navigation: {
                    nextEl: '.sfp-next',
                    prevEl: '.sfp-prev',
                },
                init: false
            });
            featProp.on('init', function () {
                $('#featured-properties').addClass('ready');
            }).init();
            swiperFeat = true;
        }
        if ($('#related-properties').length && swiperRel == false) {
            relProp = new Swiper('#related-properties', {
                autoHeight: false,
                setWrapperSize: false,
                slidesPerView: 'auto',
                spaceBetween: 20,
                centeredSlides: true,
                loop: false,
                simulateTouch: false,
                setWrapperSize: true,
                keyboard: {
                    enabled: true
                },
                preloadImages: false,
                lazy: {
                    loadPrevNext: true,
                    loadPrevNextAmount: 1,
                    elementClass: 'swiper-lazy'
                },
                a11y: {
                    enabled: true,
                    prevSlideMessage: 'Mostrar propiedad anterior',
                    nextSlideMessage: 'Mostrar propiedad siguiente',
                    firstSlideMessage: 'Es la primera propiedad',
                    lastSlideMessage: 'Es la última propiedad',
                    paginationBulletMessage: 'Mostrar propiedad {{index}}',
                },
                navigation: {
                    nextEl: '.srp-next',
                    prevEl: '.srp-prev',
                },
                breakpoints: {
                    980: {
                        slidesPerView: 3,
                        slidesPerGroup: 3,
                        centeredSlides: false,
                    }
                },
                init: false
            });
            relProp.on('init', function () {
                $('#related-properties').addClass('ready');
            }).init();
            swiperRel = true;
        }
        if ($('#lastsellout-properties').length && swiperLastSell == false) {
            lastsellProp = new Swiper('#lastsellout-properties', {
                autoHeight: false,
                setWrapperSize: false,
                slidesPerView: 'auto',
                spaceBetween: 20,
                centeredSlides: true,
                loop: false,
                simulateTouch: false,
                setWrapperSize: true,
                keyboard: {
                    enabled: true
                },
                preloadImages: false,
                lazy: {
                    loadPrevNext: true,
                    loadPrevNextAmount: 1,
                    elementClass: 'swiper-lazy'
                },
                a11y: {
                    enabled: true,
                    prevSlideMessage: 'Mostrar propiedad anterior',
                    nextSlideMessage: 'Mostrar propiedad siguiente',
                    firstSlideMessage: 'Es la primera propiedad',
                    lastSlideMessage: 'Es la última propiedad',
                    paginationBulletMessage: 'Mostrar propiedad {{index}}',
                },
                navigation: {
                    nextEl: '.slsp-next',
                    prevEl: '.slsp-prev',
                },
                init: false
            });
            lastsellProp.on('init', function () {
                $('#lastsellout-properties').addClass('ready');
            }).init();
            swiperLastSell = true;
        }
    } else {
        if (swiperFeat == true) {
            featProp.destroy();
            swiperFeat = false;
        }
        if (swiperLastSell == true) {
            lastsellProp.destroy();
            swiperLastSell = false;
        }
        if (swiperRel == true) {
            relProp.destroy();
            swiperRel = false;
        }
        if (swiperColl == true) {
            colProp.destroy();
            swiperColl = false;
        }
    }
    if ($(window).width() + scrollCompensate() < 708) {
        if ($('#collections-properties').length && swiperColl == false) {
            colProp = new Swiper('#collections-properties', {
                autoHeight: false,
                setWrapperSize: false,
                slidesPerView: 'auto',
                spaceBetween: 20,
                centeredSlides: true,
                loop: false,
                simulateTouch: false,
                setWrapperSize: true,
                keyboard: {
                    enabled: true
                },
                preloadImages: false,
                lazy: {
                    loadPrevNext: true,
                    loadPrevNextAmount: 1,
                    elementClass: 'swiper-lazy'
                },
                a11y: {
                    enabled: true,
                    prevSlideMessage: 'Mostrar colección anterior',
                    nextSlideMessage: 'Mostrar colección siguiente',
                    firstSlideMessage: 'Es la colección propiedad',
                    lastSlideMessage: 'Es la última colección',
                    paginationBulletMessage: 'Mostrar colección {{index}}',
                },
                navigation: {
                    nextEl: '.scoll-next',
                    prevEl: '.scoll-prev',
                },
                init: false
            });
            colProp.on('init', function () {
                $('#collections-properties').addClass('ready');
            }).init();
            swiperColl = true;
        }
    } else {
        if (swiperColl == true) {
            colProp.destroy();
            swiperColl = false;
        }
    }

}


// Animation elements
$window.on('scroll resize', function () {
    headerFix();
});
$window.trigger('scroll');

function headerFix() {
    if ($(window).scrollTop() > 20 && !headerFixed) {
        $('#header').addClass('small');
        headerFixed = true;
    } else if ($(window).scrollTop() <= 20 && headerFixed) {
        $('#header').removeClass('small');
        headerFixed = false;
    }
}

document.addEventListener("DOMContentLoaded", function () { 
    //SliderHome + video controls
    if ($('#swiper-gallery').length != 0) {
        swiperGal = new Swiper('#swiper-gallery', {
            init: false,
            slidesPerView: 1,
            spaceBetween: 0,
            speed: 600,
            loop: false,
            simulateTouch: false,
            navigation: {
                nextEl: '.sg-next',
                prevEl: '.sg-prev'
            },
            preloadImages: false,
            lazy: {
                loadPrevNext: true,
                loadPrevNextAmount: 1,
                elementClass: 'swiper-lazy'
            },
        }).on('init', function () {
            $('#swiper-gallery').addClass('show');
        }).on('slideChange', function () {
            $('#swiper-gallery').find('.swiper-slide.show').removeClass('show');
        });
        swiperGal.init();
    }
    if ($('#lightgallery').length != 0) {
        // $('#lightgallery').lightGallery({download:false, googlePlus: false, pinterest:false});
        const gallery = document.getElementById("lightgallery");
            let links = gallery.dataset.links
        
        lightGallery(gallery, {
            speed: 500,
            licenseKey: "9FE1C2A6-A8A3-424E-B3D8-B9172C0CF11B",
            // controls: false,
            googlePlus: false, 
            facebook: false, 
            twitter: false, 
            pinterest:false,
            download:false, 
            mobileSettings: {
                controls: false,
                showCloseIcon: false,
                download: false,
                rotate: false
              },
            plugins: [lgZoom, lgShare, lgThumbnail, lgAutoplay],
            extraProps: ['whatsapp', 'email'],
            additionalShareOptions: [
                {
                    // Selector for the anchor tag inside share list item
                    selector: '.lg-share-whatsapp',

                    // HTML to be appended to the share dropdown menu
                    dropdownHTML:
                        '<li class="lg-share-item-whatsapp"><a class="lg-share-whatsapp" target="_blank"> <span class="icon icon-whatsapp"></span></a></li>',

                    // Construct url
                    generateLink: (galleryItem) => {
                        const url = encodeURIComponent(window.location.href);

                        // The prop data-whatsapp-title is converted to whatsapp and added to the gallery item
                        const title = galleryItem.whatsapp;
                        const whatsappShareLink = `whatsapp://send?text=https://thesingular.space${links}`;
                        return whatsappShareLink;
                    },
                },
                {
                    // Selector for the anchor tag inside share list item
                    selector: '.lg-share-email',

                    // HTML to be appended to the share dropdown menu
                    dropdownHTML:
                        '<li class="lg-share-item-email"><a class="lg-share-email" target="_blank"> <span class="icon icon-envelope"></span></a></li>',

                    // Construct url
                    generateLink: (galleryItem) => {
                        const url = encodeURIComponent(window.location.href);

                        // The prop data-email-title is converted to email and added to the gallery item
                        const title = galleryItem.email;
                        const emailShareLink = `mailto:?body=https://thesingular.space${links}`;
                        return emailShareLink;
                    },
                },
                {
                    // Selector for the anchor tag inside share list item
                    selector: '.lg-share-facebook',

                    // HTML to be appended to the share dropdown menu
                    dropdownHTML:
                        '<li class="lg-share-item-facebook"><a class="lg-share-facebook" target="_blank"> <span class="icon icon-facebook"></span></a></li>',

                    // Construct url
                    generateLink: (galleryItem) => {
                        const url = encodeURIComponent(window.location.href);

                        // The prop data-facebook-title is converted to facebook and added to the gallery item
                        const title = galleryItem.facebook;
                        const facebookShareLink = `https://www.facebook.com/sharer/sharer.php?u=https://thesingular.space${links}`;
                        return facebookShareLink;
                    },
                },
                {
                    // Selector for the anchor tag inside share list item
                    selector: '.lg-share-twitter',

                    // HTML to be appended to the share dropdown menu
                    dropdownHTML:
                        '<li class="lg-share-item-twitter"><a class="lg-share-twitter" target="_blank"> <svg viewBox="0 0 50 50"><path d="M 5.9199219 6 L 20.582031 27.375 L 6.2304688 44 L 9.4101562 44 L 21.986328 29.421875 L 31.986328 44 L 44 44 L 28.681641 21.669922 L 42.199219 6 L 39.029297 6 L 27.275391 19.617188 L 17.933594 6 L 5.9199219 6 z M 9.7167969 8 L 16.880859 8 L 40.203125 42 L 33.039062 42 L 9.7167969 8 z"></path></svg></a></li>',

                    // Construct url
                    generateLink: (galleryItem) => {
                        const url = encodeURIComponent(window.location.href);

                        // The prop data-twitter-title is converted to twitter and added to the gallery item
                        const title = galleryItem.twitter;
                        const twitterShareLink = `https://x.com/home?status=https://thesingular.space${links}`;
                        return twitterShareLink;
                    },
                },
              
            ],
        });
        document.querySelector(".btn-open-lg0")?.addEventListener("click", function (e) {
            e.preventDefault();
            gallery.children[0].click(); // Abre la primera imagen
        });
        $(document).on("click", ".btn-open-lg1", function (e) {
            e.preventDefault();

            $('#lightgallery li').eq(1).trigger("click");
        });
        document.querySelectorAll("#swiper-gallery .swiper-slide").forEach((slide, index) => {
            slide.addEventListener("click", function () {
                gallery.children[index]?.click();
            });
        });

    }
})

$(function () {

    if ($('.grid-mag').length > 0) {
        console.log("grid entra");
        $('.grid-mag').masonry({
            columnWidth: '.item-sizer',
            itemSelector: '.item',
            percentPosition: true,
            gutter: 0
        })
        $('.grid-mag').addClass('show');
    }
    setTimeout(function () {
        if (showNewsletter)
            $('#modalNews').modal('show');

    }, 3000);

    $('a[href*=#]:not([href=#])').click(function () {
        if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
            var target = $(this.hash);
            target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
            if (target.length) {
                $('html,body').animate({
                    scrollTop: target.offset().top - 100
                }, 1000);
                return false;
            }
        }
    });

    $.material.checkbox();
    // Controlar si ha saltado version mobile
    if ($(window).width() + scrollCompensate() < 760) {
        mobile = true;
    }

    //select2 a todos los selects
    $('select').select2();


    //controles menú
    $(document).on("click", "#btn-menu", function () {
        $('body').toggleClass('menu-open');
        $('html,body').toggleClass('ohidden');
        $(this).toggleClass('active');
    }).on("click", "button[data-open='modal-cita']", function () {
        $('#modal-cita').addClass('show');
        $('html,body').addClass('ohidden');
    }).on("click", "#btn-mc-close", function () {
        $('#modal-cita').removeClass('show');
        $('html,body').removeClass('ohidden');
    }).on("click", "#btn-clearfilters", function () {
        $('html,body').removeClass('ohidden');
    });

    //Control video sliderHome ends
    if ($('#vid').length != 0) {
        vid = document.getElementById("vid");
        vid.addEventListener('ended', controlVid, false);
        function controlVid(e) {
            statusVid = false;
            swiperTop.slideNext();
            swiperTop.autoplay.start();
        };
    }
    /*if ($('#swiper-gallery').length != 0) {
        $('#swiper-gallery').lightGallery({download:false});
    }*/
  
    //SliderHome + video controls
    if ($('#swiperTop').length != 0) {
        swiperTop = new Swiper('#swiperTop', {
            init: false,
            slidesPerView: 1,
            spaceBetween: 0,
            speed: 600,
            effect: 'fade',
            simulateTouch: true,
            loop: false,
            /*navigation: {
                nextEl: '.sc-next',
                prevEl: '.sc-prev'
            },*/
            pagination: {
                el: '.swtop-pagination',
                type: 'bullets',
            },
            // Disable preloading of all images
            preloadImages: false,
            lazy: {
                loadPrevNext: true,
                loadPrevNextAmount: 1,
                elementClass: 'swiper-lazy'
            },
            autoplay: {
                delay: 6000,
            },
        }).on('init', function () {
            $('#swiperTop').find('.swiper-slide-active').addClass('show');
            if ($('#swiperTop .show').hasClass('videoControl') && !statusVid) {
                vid.play();
                statusVid = true;
                $('#vid').closest('.videoControl').removeClass('play');
                swiperTop.autoplay.stop();
            }
        }).on('slideChange', function () {
            $('#swiperTop').find('.swiper-slide.show').removeClass('show');
            setTimeout(function () {
                $('#swiperTop').find('.swiper-slide-active').addClass('show');
                if ($('#swiperTop .show').hasClass('videoControl') && !statusVid) {
                    vid.play(); statusVid = true;
                    $('#vid').closest('.videoControl').removeClass('play');
                    swiperTop.autoplay.stop();
                } else if (statusVid) {
                    vid.pause(); statusVid = false;
                    $('#vid').closest('.videoControl').addClass('play');
                    swiperTop.autoplay.start();
                }
            }, 100);
        });
        swiperTop.init();
    }
    

    // Porgramación para abrir cualquier enlace con data-toogle="lightbox" en modal
    $(document).delegate('*[data-toggle="lightbox"]', 'click', function (event) {
        event.preventDefault();
        var dt = $(this).attr('data-type');
        if (dt == "youtube" || dt == "video" || dt == "url") {
            $(this).ekkoLightbox({
                alwaysShowClose: true,
                onShow: function () {
                    $('.ekko-lightbox').addClass(dt);
                    $('html,body').addClass('ohidden');
                },
                onHidden: function () {
                    $('html,body').removeClass('ohidden');
                },
            });
        } else {
            $(this).ekkoLightbox();
        }
    });


    // filtros Propiedades
    $(document).on("click", "button[data-open='collapse']", function () {
        var $id = $(this).data('target');
        $($id).collapse('show');
        if (!headerFixed) { $('#header').addClass('small'); headerFixed = true; }
        if (mobile) { $('html,body').addClass('ohidden'); }
    }).on("click", "#sell-filters .collapse .btn-primary", function () {
        if (mobile) { $('html,body').removeClass('ohidden'); }
    });

    // Control collapses filtros Propiedades
    if ($('#sell-filters').length != 0) {
        $('#sell-filters .collapse').on('show.bs.collapse', function () {
            var $idColl = $(this).attr('aria-labelledby');
            $('#' + $idColl).parent().parent().find('.btn-link').addClass('collapsed').attr('aria-expanded', false);
            $('#' + $idColl).removeClass('collapsed').attr('aria-expanded', true);
        });
        //cerrar subfilters al perder foco
        if (!mobile) {
            $('#sell-filters .nav-subfilters > div .collapse').mouseleave(function () {
                $(this).collapse('hide');
            });
            //cerrar collectionfilters 
            $('#collCollections').mouseleave(function () {
                $(this).collapse('hide');
            });

        }
    }
    // plegar/desplegar logo header en mobile
    if ($('#coll-searchProp').length != 0) {
        $('#coll-searchProp').on('show.bs.collapse', function () {
            if (!headerFixed) { $('#header').addClass('small'); headerFixed = true; }
        }).on('hidden.bs.collapse', function () {
            if ($(window).scrollTop() <= 20 && headerFixed) { $('#header').removeClass('small'); headerFixed = false; }
        });
    }

    /*$(document).click(function (event) {
      $('#sell-filters .collapse').each( function () {
           var $idColl = $(this).attr('aria-labelledby');
           
           var clickover = $(event.target);
           var _opened = $(this).hasClass("show");
           var type_menu = $('#'+$idColl).hasClass("type_menu");
           console.log(clickover.attr("class"));

           var over = (clickover.hasClass("ng-valid") || clickover.hasClass("checkbox") || clickover.hasClass("check") || clickover.hasClass("btn-link") || clickover.hasClass("control-label") ) ;


           if (_opened === true && over===false && type_menu===false) {
               
               
               $('#'+$idColl).addClass('collapsed').attr('aria-expanded',true);
               $(this).removeClass('show');
           }

       });
   });*/

    resize();

    jQuery("#searchForm").on("submit", function (e) {

        if (jQuery("#collectionSelect").val().indexOf("/") !== -1) {

            window.location.href = jQuery("#collectionSelect").val();
            return false;
        }


        return true;

    });

});
function sendLlamada(cont_id) {
    $('.form_' + cont_id + ' .btn-enviar').hide();
    $('.form_' + cont_id + ' .btn-enviando').show();
    $('.form_' + cont_id + ' .btn-enviarForm').prop("disabled", true);
    var csrfToken = $('meta[name="csrf-token"]').attr("content");
    var json = $('.form_' + cont_id).serializeObject();
    var form = document.querySelector('.form_' + cont_id);
    var formData = new FormData(form);

    formData.append("_csrf", csrfToken);
    formData.append("lang_id", lang_id);
    formData.append("cont_id", cont_id);
    formData.append("json", JSON.stringify(json));
    formData.append("page", window.location.href);
    $.ajax({
        url: "/ajax/sendllamada",
        type: 'POST',
        data: formData,
        dataType: 'json',
        async: false,
        success: function (data) {
            if (data.onsentok.trim() != "" && data.code == 1) {
                eval(data.onsentok);
            }
            if (data.onsubmit.trim() != "" && data.code != 1) {
                eval(data.onsubmit);
            }
            if (data.code == 1) {
                $('.form_' + cont_id + ' .msgOK').html(data.msgok);
                $('.form_' + cont_id + ' .msgOK').show();
                $('.form_' + cont_id).addClass('sended');
                $('.form_' + cont_id + ' input[type="text"],.form_' + cont_id + ' input[type="email"]').val("");
            } else {
                $('.form_' + cont_id + ' .msgKO').show();
            }
            $('.form_' + cont_id + ' .btn-enviarForm').prop("disabled", false);
            $('.form_' + cont_id + ' .btn-enviar').show();
            $('.form_' + cont_id + ' .btn-enviando').hide();
        },
        cache: false,
        contentType: false,
        processData: false
    })
}
function sendNewsletter(cont_id) {
    $('.form_' + cont_id + ' .btn-enviar').hide();
    $('.form_' + cont_id + ' .btn-enviando').show();
    $('.form_' + cont_id + ' .btn-enviarForm').prop("disabled", true);
    var csrfToken = $('meta[name="csrf-token"]').attr("content");
    var json = $('.form_' + cont_id).serializeObject();
    var form = document.querySelector('.form_' + cont_id);
    var formData = new FormData(form);

    formData.append("_csrf", csrfToken);
    formData.append("lang_id", lang_id);
    formData.append("cont_id", cont_id);
    formData.append("json", JSON.stringify(json));
    formData.append("page", window.location.href);
    $.ajax({
        url: "/ajax/sendnewsletter",
        type: 'POST',
        data: formData,
        dataType: 'json',
        async: false,
        success: function (data) {

            if (data.onsentok.trim() != "" && data.code == 1) {
                eval(data.onsentok);
            }
            if (data.onsubmit.trim() != "" && data.code != 1) {
                eval(data.onsubmit);
            }

            if (data.code == 1) {

                $('.form_' + cont_id + ' .msgOK').html(data.msgok);
                $('.form_' + cont_id + ' .msgOK').show();

                $('.form_' + cont_id).addClass('sended');
                $('.form_' + cont_id + ' input[type="text"],.form_' + cont_id + ' input[type="email"]').val("");
            } else {
                $('.form_' + cont_id + ' .msgKO').show();
            }
            $('.form_' + cont_id + ' .btn-enviarForm').prop("disabled", false);
            $('.form_' + cont_id + ' .btn-enviar').show();
            $('.form_' + cont_id + ' .btn-enviando').hide();
        },
        cache: false,
        contentType: false,
        processData: false
    })
}
function sendProperty(cont_id) {
    $('.form_' + cont_id + ' .btn-enviar').hide();
    $('.form_' + cont_id + ' .btn-enviando').show();
    $('.form_' + cont_id + ' .btn-enviarForm').prop("disabled", true);
    var csrfToken = $('meta[name="csrf-token"]').attr("content");
    var json = $('.form_' + cont_id).serializeObject();
    var form = document.querySelector('.form_' + cont_id);
    var formData = new FormData(form);

    formData.append("_csrf", csrfToken);
    formData.append("lang_id", lang_id);
    formData.append("cont_id", cont_id);
    formData.append("json", JSON.stringify(json));
    formData.append("page", window.location.href);
    $.ajax({
        url: "/ajax/sendproperty",
        type: 'POST',
        data: formData,
        dataType: 'json',
        async: false,
        success: function (data) {
            if (data.onsentok.trim() != "" && data.code == 1) {
                eval(data.onsentok);
            }
            if (data.onsubmit.trim() != "" && data.code != 1) {
                eval(data.onsubmit);
            }
            if (data.code == 1) {
                $('.form_' + cont_id + ' .msgOK').html(data.msgok);
                $('.form_' + cont_id + ' .msgOK').show();
                $('.form_' + cont_id).addClass('sended');
                $('.form_' + cont_id + ' input[type="text"],.form_' + cont_id + ' input[type="email"]').val("");
            } else {
                $('.form_' + cont_id + ' .msgKO').show();
            }
            $('.form_' + cont_id + ' .btn-enviarForm').prop("disabled", false);
            $('.form_' + cont_id + ' .btn-enviar').show();
            $('.form_' + cont_id + ' .btn-enviando').hide();
        },
        cache: false,
        contentType: false,
        processData: false
    })
}


$(window).resize(function () {
    resize();
});


if (document.body.classList.contains('index') && !localStorage.getItem('visited')) {
    setTimeout(() => {
        $('#modalNews').modal('show')
        localStorage.setItem('visited', 'true');
    }, 5000);
}



// VIDEOS VLITE
// $(document).ready(()=> {

//     if(document.querySelector('.video-vlite')) {
//         let vliteConfig = {};
//         let provider = null;
//         let poster;
//         let options = {
//             controls: true,
//             volume: true,
//             fullscreen: true,
//             loop: false,
//             muted: false,
//             playPause: true,
//             progressBar: true,
//             time: true,
//             bigPlay: false,
//             autoplay: false,
//         };
//         document.querySelectorAll('.video-vlite').forEach(video => {
//             if(video.classList.contains('video-yt')) {
//                 provider = "youtube";
//             }
//             if(video.classList.contains('video-v')) {
//                 provider = "vimeo";
//             }
//             if(video.dataset.poster) {
//                 poster = video.dataset.poster;
//             }
//             let vliteConfig = {
//                 options: options,
//             };
//             if (provider) {
//                 vliteConfig.provider = provider;
//             }
//             if (poster) {
//                 vliteConfig.options.poster = poster;
//             }
//             new window.Vlitejs(video, vliteConfig);
//         });
//     }
// });